// Map raw GPS coordinates to a Lokaso city slug using bounding boxes.
//
// Guinea businesses do not currently carry lat/lng themselves, so we
// approximate "near me" by matching the user's GPS to the closest known
// city bounding box. This is intentionally coarse — it answers
// "which Guinean city am I in?" not "which exact street?".
//
// Coordinates sourced from public geographic centroids + ~0.25° padding.

const CITIES = [
  { slug: "conakry",      name: "Conakry",      lat: 9.6412,  lng: -13.5784 },
  { slug: "kindia",       name: "Kindia",       lat: 10.0561, lng: -12.8658 },
  { slug: "labe",         name: "Labé",         lat: 11.3182, lng: -12.2833 },
  { slug: "mamou",        name: "Mamou",        lat: 10.3756, lng: -12.0911 },
  { slug: "boke",         name: "Boké",         lat: 10.9333, lng: -14.2917 },
  { slug: "faranah",      name: "Faranah",      lat: 10.0400, lng: -10.7456 },
  { slug: "kankan",       name: "Kankan",       lat: 10.3853, lng: -9.3066 },
  { slug: "kissidougou",  name: "Kissidougou",  lat: 9.1853,  lng: -10.0992 },
  { slug: "nzerekore",    name: "Nzérékoré",    lat: 7.7561,  lng: -8.8175 },
  { slug: "siguiri",      name: "Siguiri",      lat: 11.4178, lng: -9.1681 },
  { slug: "macenta",      name: "Macenta",      lat: 8.5500,  lng: -9.4667 },
];

// Approx Guinea bounding box (very generous)
const GUINEA_BBOX = { latMin: 7.0, latMax: 12.7, lngMin: -15.1, lngMax: -7.5 };

function haversineKm(lat1, lng1, lat2, lng2) {
  const toRad = (d) => (d * Math.PI) / 180;
  const R = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

/**
 * Find the closest Lokaso city given user GPS coords.
 * Returns null if the user is far outside Guinea (>600 km from any city).
 */
export function nearestGuineaCity(lat, lng) {
  if (lat < GUINEA_BBOX.latMin - 2 || lat > GUINEA_BBOX.latMax + 2) return null;
  if (lng < GUINEA_BBOX.lngMin - 2 || lng > GUINEA_BBOX.lngMax + 2) return null;

  let best = null;
  let bestDist = Infinity;
  for (const c of CITIES) {
    const d = haversineKm(lat, lng, c.lat, c.lng);
    if (d < bestDist) {
      bestDist = d;
      best = { ...c, distance_km: Math.round(d) };
    }
  }
  if (!best || bestDist > 600) return null;
  return best;
}
